import LockScreenProvider from "./LockScreenProvider"
export default LockScreenProvider
